import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

// Scroll to top on every route/location change using Router context
export default function ScrollToTop({ children }) {
	const location = useLocation();

	useEffect(() => {
		try { window.scrollTo(0, 0); } catch (_) { }
	}, [location.pathname, location.search, location.hash]);

	return children ?? null;
}

ScrollToTop.propTypes = {
	children: PropTypes.any,
};
